class ProductDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-product-tab]');
    this.panels = this.querySelectorAll('[data-product-panel]');

    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.productTab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });
  }

  activate(name) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.productTab === name;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.productPanel === name;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  onKeydown(event, tab) {
    const tabs = Array.from(this.tabs);
    const index = tabs.indexOf(tab);
    let nextIndex = index;

    if (event.key === 'ArrowRight') {
      nextIndex = (index + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (index - 1 + tabs.length) % tabs.length;
    } else {
      return;
    }

    event.preventDefault();
    tabs[nextIndex].focus();
    this.activate(tabs[nextIndex].dataset.productTab);
  }
}

if (!customElements.get('product-details-tabs')) {
  customElements.define('product-details-tabs', ProductDetailsTabs);
}
